let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eow5n")).then(() => parcelRequire('aM59p'));